import React from 'react';
import { ILesson } from '../../../../types/ThemeType';
import { nanoid } from 'nanoid';
import classes from './style/Playlist.module.css';
interface PlaylistProps {
  lessons: ILesson[];
  handleClick: (id: number) => void;
}
const Playlist = (lessons: PlaylistProps) => {
  if (!Array.isArray(lessons.lessons)) {
    return null;
  }

  const sortLessons = lessons.lessons.sort(
    (itemA: ILesson, itemB: ILesson) => itemA.lesson_order - itemB.lesson_order
  );
  return (
    <div className={classes.playerWrapper}>
      <h1>Плейлист по теме</h1>
      {sortLessons.map((item: ILesson) => {
        const key = nanoid();
        return (
          <div
            key={key}
            className={item.isPlaying ? classes.rectangleWrapperActive : classes.rectangleWrapper}
            onClick={() => lessons.handleClick(item.id)}
          >
            <div className={classes.rectangle}>
              {item.video_link ? (
                <div className={classes.triangle}></div>
              ) : (
                <div className={classes.rectangle_line}>
                  <div className={classes.line_line1}></div>
                  <div className={classes.line_line2}></div>
                  <div className={classes.line_line3}></div>
                  <div className={classes.line_line4}></div>
                  <div className={classes.line_line5}></div>
                </div>
              )}
            </div>
            <div className={classes.description}>
              <h4>{`Урок ${item.lesson_order}. ${item.title}`}</h4>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Playlist;
